var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100% height:100%"},attrs:{"id":"body"}},[_c('div',{staticClass:"container",staticStyle:{"width":"100% height:100%"}},[_c('iframe',{ref:"iframeDom",attrs:{"name":"kinipage","id":"frameId","src":_vm.getPageUrl,"width":"100%","height":"100%","frameborder":"0","scrolling":"auto"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }